import { useEffect } from "react";

/**
 * Imperatively update <head> for SEO / OpenGraph per page.
 * No extra library needed — sets title, description, canonical, OG tags.
 */
function setMeta(name, content, attr = "name") {
  if (content === undefined || content === null) return;
  let el = document.head.querySelector(`meta[${attr}="${name}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, name);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

function setLink(rel, href) {
  let el = document.head.querySelector(`link[rel="${rel}"]`);
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", rel);
    document.head.appendChild(el);
  }
  el.setAttribute("href", href);
}

export function useMeta({
  title,
  description,
  image,
  url,
  type = "website",
  siteName = "GentleGiTo",
} = {}) {
  useEffect(() => {
    const fullTitle = title ? `${title} · GentleGiTo` : "GentleGiTo · Gentle connection across generations";
    const desc =
      description ||
      "Thoughtful reflections and practical guidance for grandparents navigating love, distance, boundaries, and belonging.";
    const pageUrl = url || (typeof window !== "undefined" ? window.location.href : "");
    const imgUrl =
      image ||
      "https://customer-assets.emergentagent.com/job_across-generations/artifacts/xxwpow14_file_00000000708071f8a14ea4cd794bda2a.png";

    const prevTitle = document.title;
    document.title = fullTitle;

    setMeta("description", desc);
    setMeta("og:title", fullTitle, "property");
    setMeta("og:description", desc, "property");
    setMeta("og:type", type, "property");
    setMeta("og:url", pageUrl, "property");
    setMeta("og:site_name", siteName, "property");
    setMeta("og:image", imgUrl, "property");
    setMeta("twitter:card", "summary_large_image");
    setMeta("twitter:title", fullTitle);
    setMeta("twitter:description", desc);
    setMeta("twitter:image", imgUrl);
    if (pageUrl) setLink("canonical", pageUrl);

    return () => {
      document.title = prevTitle;
    };
  }, [title, description, image, url, type, siteName]);
}
